import { render } from "./table2.vue?vue&type=template&id=28dc2c58&scoped=true"
import script from "./table2.vue?vue&type=script&lang=js"
export * from "./table2.vue?vue&type=script&lang=js"

import "./table2.vue?vue&type=style&index=0&id=28dc2c58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28dc2c58"]])

export default __exports__